import { render } from "./Pagamenti.vue?vue&type=template&id=3df5aabf&scoped=true"
import script from "./Pagamenti.vue?vue&type=script&lang=js"
export * from "./Pagamenti.vue?vue&type=script&lang=js"

import "./Pagamenti.vue?vue&type=style&index=0&id=3df5aabf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df5aabf"]])

export default __exports__